import { HcLazyload } from '@iris.interactive/handcook/public/scripts/components/lazyload/lazyload.component'

export default class TabsHomeComponent {
    static isAjaxRunning = false

    constructor() {
        if ($('.strate--needs').length > 0) {
            TabsHomeComponent.onClick()

            if ($('.strate--needs .strate__tabs').length > 0) {
                TabsHomeComponent.detectSticky($('.strate--needs .strate__tabs'))
            }
        }
    }

    static onClick() {
        const tab = '[data-trigger="needs-tab"]'
        let previousActiveTab = '0'

        $(tab).on('click', function () {
            const activeTab = $(this).data('id')

            if (previousActiveTab === activeTab) return

            if (!TabsHomeComponent.isAjaxRunning) {
                TabsHomeComponent.isAjaxRunning = true
                TabsHomeComponent.ajaxContent(activeTab)

                $(tab).removeClass('active')
                $(this).addClass('active')
                previousActiveTab = activeTab
            }
        })
    }

    static ajaxContent(tabId) {
        const contentWrapper = '[data-element="ajax-tabs-posts"]'

        $(`${contentWrapper}, .strate__tabs__title[data-id='${tabId}']`).addClass(
            `ajax-tabs-loading ${tabId}`,
        )

        // If we're on mobile, make the clicked component scroll to top of viewport
        if (window.matchMedia('(max-width: 1000px)').matches) {
            window.scrollBy({
                top:
                    $('.strate--needs .strate__paragraph')[0].getBoundingClientRect().bottom +
                    Number.parseInt($('.strate--needs .strate__paragraph').css('marginBottom')),
                behavior: 'smooth',
            })
            console.log(navigator)
            // Check if event scrollend is supported by the browser
            if ('onscrollend' in window) {
                window.addEventListener(
                    'scrollend',
                    () => {
                        console.log('scrollend')
                        $('body').addClass('header-is-hidden')
                    },
                    { once: true },
                )
            }
        }

        $.ajax({
            url: IRISCollectionCustomer.ajaxUrl,
            data: {
                action: 'get_tab_posts',
                datas: {
                    tab: tabId,
                },
            },
            method: 'POST',
        }).done((response) => {
            $('[data-element="ajax-tabs-posts"]').html(response)
            TabsHomeComponent.isAjaxRunning = false
            HcLazyload.update()
            $('.strate__tabs__title').removeClass('ajax-tabs-loading')
            $('.strate__posts').removeClass('ajax-tabs-loading')
        })
    }

    static detectSticky(element) {
        if (window.matchMedia('(max-width: 1000px)').matches) {
            const sectionViewObserver = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            entry.target.classList.add('is-sticky')
                        } else {
                            entry.target.classList.remove('is-sticky')
                        }
                    })
                },
                { rootMargin: '0px 0px 100% 0px' },
            )
            sectionViewObserver.observe(element[0])
        }
    }
}
